import { selectPlayerStatus, setChaptersTabEntries, setCurrentChapterCueId } from "@adm-media/adam-store-plugin";
import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../store";
import { VOD } from "../types/player";
var toBookmarks = function (cues) { return cues.map(function (cue) { return ({ id: cue.id, offset: cue.startTime, content: cue.text }); }); };
export var useSetDrawerChapters = function (_a) {
    var playerRef = _a.playerRef, playerReadyState = _a.playerReadyState;
    var dispatch = useAppDispatch();
    var playerStatus = useSelector(selectPlayerStatus);
    // setSource() clears the player's bookmark markers unconditionally, and it's called
    // again any time the (memoized but not deep-equal) formattedPlayerSource reference
    // changes — even for the same episode. Keep the last cues around so the sourceset
    // listener below can redraw the ticks without waiting for the chapters track to reload.
    var cuesRef = useRef([]);
    useEffect(function () {
        if (playerStatus !== VOD || !playerRef || playerReadyState !== 4 || playerRef.readyState !== 4) {
            dispatch(setChaptersTabEntries([]));
            playerRef === null || playerRef === void 0 ? void 0 : playerRef.setBookmarks([]);
            cuesRef.current = [];
            return;
        }
        var cues = playerRef.getChapterCues();
        cuesRef.current = cues;
        dispatch(setChaptersTabEntries(cues.map(function (cue) { return ({
            id: cue.id,
            startTime: cue.startTime,
            endTime: cue.endTime,
            content: cue.text
        }); })));
        // Ticks on the progress bar marking each chapter's start.
        playerRef.setBookmarks(toBookmarks(cues));
    }, [dispatch, playerStatus, playerRef, playerReadyState]);
    var handleSourceSet = useCallback(function () {
        if (cuesRef.current.length > 0)
            playerRef === null || playerRef === void 0 ? void 0 : playerRef.setBookmarks(toBookmarks(cuesRef.current));
    }, [playerRef]);
    useEffect(function () {
        playerRef === null || playerRef === void 0 ? void 0 : playerRef.on("sourceset", handleSourceSet);
        return function () { return playerRef === null || playerRef === void 0 ? void 0 : playerRef.off("sourceset", handleSourceSet); };
    }, [playerRef, handleSourceSet]);
    var handleChapterEnterCue = useCallback(function (_a) {
        var cue = _a.cue;
        dispatch(setCurrentChapterCueId(cue.id));
    }, [dispatch]);
    useEffect(function () {
        playerRef === null || playerRef === void 0 ? void 0 : playerRef.on("chapterentercue", handleChapterEnterCue);
        return function () { return playerRef === null || playerRef === void 0 ? void 0 : playerRef.off("chapterentercue", handleChapterEnterCue); };
    }, [playerRef, handleChapterEnterCue]);
};
